import React from "react";
import PropTypes from "prop-types";
import InputGroup from "reactstrap/lib/InputGroup";
import InputGroupAddon from "reactstrap/lib/InputGroupAddon";
import InputGroupText from "reactstrap/lib/InputGroupText";

import Icon from "../icon/icon";
import Input from "../input/input";
import { Calendar } from "../../lib/icons";
import { createCustomInput } from "./datepickerUtils";
import { gatherClasses } from "../../lib/utils";

const DateInput = ({
  isClearable,
  isInvalid,
  className,
  inputRef,
  disabled,
  value,
  onClick,
  ariaLabel,
  ...props
}) => (
  <InputGroup
    className={gatherClasses(
      null,
      isInvalid ? "invalid-date-input" : "",
      disabled ? "input-disabled" : ""
    )}
  >
    <Input
      className={gatherClasses(
        null,
        className,
        isClearable && value ? "clearable" : ""
      )}
      type="text"
      {...props}
      onClick={onClick}
      value={value}
      disabled={disabled}
      readOnly={!disabled}
      innerRef={inputRef}
      aria-label={ariaLabel}
    />
    <InputGroupAddon addonType="append" onClick={onClick}>
      <InputGroupText>
        <Icon src={Calendar} />
      </InputGroupText>
    </InputGroupAddon>
  </InputGroup>
);

DateInput.displayName = "OrionDatePickerInput";

DateInput.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  inputRef: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string,
    PropTypes.func
  ]),
  isClearable: PropTypes.bool,
  isInvalid: PropTypes.bool,
  onClick: PropTypes.func,
  value: PropTypes.string,
  ariaLabel: PropTypes.string
};

export default createCustomInput(DateInput);
